module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAdUlEQVQokbWQSwqEQAxEXxq9keDW69vOddwMtHFholk42iNYkE9BVQoCDyAAquo8AwlQq13jU0S65uRQdxHyAXBTtpls18Bn2wdgiaZUk2C6rf0LNy03um/U1Sa1MaTWJMAIFDgecYcC9E7i96YfCaXy8AtYAS32FK8WLCxMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/mail_big.png
// module id = XL5K
// module chunks = 0